import React from 'react';

import {Row} from '@unthinkable/react-core-components';
import {getCurrentMonth} from '@unthinkable/react-filters/src/DateUtility';
import {AddButton} from '../../../components/button/AddButton';
import {
  GroupFilter,
  PeriodRangeFilter,
} from '../../../components/filter/Filters';
import {TabView} from '../../../components/tab/TabView';
import {useFilter} from '../../../controllers/useFilter';
import {OutreachCampaigns} from './OutreachCampaigns';

export const OutreachCampaignTabs = props => {
  const {
    route: {params},
    navigation,
  } = props;
  const {
    onChangeFilter,
    searchValue,
    applyFilter,
    filterValues = {},
  } = useFilter({
    params: {
      period: params.period || getCurrentMonth(),
      target_audience: params?.target_audience || {},
    },
  });
  const {filter, params: filterParams} = filterValues || {};
  const tabs = {
    inexperiment: {
      label: 'In Experiment',
      view: (
        <OutreachCampaigns
          filterParams={filterParams}
          filter={filter}
          searchValue={searchValue}
          tab={'Active'}
          tabFilter={{
            status: 'In Experiment',
          }}
        />
      ),
    },
    confirmed: {
      label: 'Confirmed',
      view: (
        <OutreachCampaigns
          filterParams={filterParams}
          filter={filter}
          tab={'Active'}k
          searchValue={searchValue}
          tabFilter={{
            status: 'Confirmed',
          }}
        />
      ),
    },

    retired: {
      label: 'Retired',
      view: (
        <OutreachCampaigns
          filterParams={filterParams}
          filter={filter}
          searchValue={searchValue}
          tabFilter={{status: 'Retired'}}
        />
      ),
    },
    failed: {
      label: 'Failed',
      view: (
        <OutreachCampaigns
          filterParams={filterParams}
          filter={filter}
          searchValue={searchValue}
          tabFilter={{status: 'Failed'}}
        />
      ),
    },
  };
  const actions = [
    <PeriodRangeFilter
      onChangeFilter={onChangeFilter}
      filterValues={filterValues}
      // options={[
      //   {
      //     label: 'Week',
      //     value: 'week',
      //   },
      //   {
      //     label: 'Today',
      //     value: 'day',
      //   },
      // ]}
    />,
    <GroupFilter
      filterValues={filterValues}
      applyFilter={applyFilter}
      filters={[
        {
          type: 'autoComplete',
          label: 'Owner',
          api: '/employeeSuggestions',
          placeholder: 'Select',
          suggestionField: 'name',
          valueField: 'name',
          field: 'assigned_to',
        },
      ]}
    />,
    <Row
      gap={8}
      style={{alignItems: 'center', justifyContent: 'space-between'}}>
      <AddButton
        title="Campaign"
        view="add-campaign-form"
        params={props?.route?.params}
      />
    </Row>,
  ];
  return <TabView {...props} tabs={tabs} actions={actions} />;
};
